import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { createPatientApi } from "../../../api-helpers/PatientApiHelper";
import { createCommonUtilsApi } from "../../../api-helpers/CommonUtilsApiHelper";
import Lookups from "../../../constants/Lookups";
import { Lookup } from "common-util-experience-client";
import { formateDate } from "../../schedule/dateFormat";

interface SummaryConditionCardProps {
  variant?: "list" | "count" | "compact-list" | "care-record";
  limit?: number;
  patientId?: string;
}

export const SummaryConditionCard = ({
  variant = "list",
  limit = 4,
  patientId: propPatientId,
}: SummaryConditionCardProps = {}) => {
  const [conditions, setConditions] = useState<any>({ data: [], total: 0 });
  const [loading, setLoading] = useState<boolean>(true);

  const { patientId: routePatientId } = useParams<{ patientId: string }>();
  const patientId = propPatientId || routePatientId;
  const patientApi = createPatientApi();
  const lookupApi = createCommonUtilsApi();

const getActiveConditionStatus = async (): Promise<string[]> => {
    let response, conditionStatus: Lookup[] = [];
    try {
      response = await lookupApi.lookupControllerFindAll(Lookups.CONDITION_STATUS);
      conditionStatus = response.data.filter((lookup: Lookup) => lookup.name?.toLowerCase() === "active");
    } catch (error) {
      console.log(error);
    }
    return conditionStatus.length > 0 ? [conditionStatus[0].id] : [];
};
const getConditions = async () => {
    try {
      const activeConditionId = await getActiveConditionStatus();
      const conditionsPayload = {
        filters: [
          {
            propertyName: "patientId",
            operator: "equals",
            propertyValue: patientId,
          },
          {
            propertyName: "status",
            operator: "in",
            propertyValue: activeConditionId,
            updateFilter: true,
          },
        ],
        sortCriteria: [{ propertyName: "onsetDate", descending: true }],
        startRow: 0,
        endRow: 0,
      };
      const response = await patientApi.patientsControllerGetConditionGridData(conditionsPayload);
      setConditions(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getConditions()
  }, []);
  

  if (variant === "count") {
    return (
      <div className="patient-summary-compact-card__body">
        {loading ? (
          "Loading..."
        ) : conditions.total > 0 ? (
          `${conditions.total} active condition${conditions.total === 1 ? "" : "s"}`
        ) : (
          <span className="patient-summary-empty-badge">No data</span>
        )}
      </div>
    );
  }

  if (variant === "care-record") {
    // design_handoff_patient_summary (option 2a): "Care record" band.
    if (loading) return null;
    if (conditions.total === 0) {
      return <span className="ps-empty">No conditions recorded</span>;
    }
    return (
      <div className="ps-record-list">
        {conditions.data.slice(0, limit).map((condition: any) => (
          <div className="ps-record-row" key={condition.conditionId}>
            <span className="ps-record-row__date">
              {formateDate(condition.onsetDate, "UTC")}
            </span>
            <span className="ps-record-row__desc">{condition.conditionName}</span>
            <span />
          </div>
        ))}
      </div>
    );
  }

  if (variant === "compact-list") {
    return (
      <div className="patient-summary-compact-card__body">
        {loading ? (
          "Loading..."
        ) : conditions.total > 0 ? (
          <div className="patient-summary-row-list">
            {conditions.data.slice(0, limit).map((condition: any) => (
              <div className="patient-summary-row-list__row" key={condition.conditionId}>
                <span className="patient-summary-row-list__label">
                  {condition.conditionName}
                </span>
                <span className="patient-summary-row-list__meta">
                  {formateDate(condition.onsetDate, "UTC")}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <span className="patient-summary-empty-badge">No data</span>
        )}
      </div>
    );
  }

  return (
    <div className="bg-white rounded p-0 fs-12 sidebar__content-scroll">
  {/* Conditional rendering of headers and data */}
  {loading ? (
    <div className="d-flex d-block p-3">
      <span className="w-100 text-center">Loading...</span>
    </div>
  ) : conditions.total > 0 ? (
    <>
      {/* Table Column Headers */}
      <div className="d-flex d-block p-3 hover-bg">
        <strong className="w-85">Conditions</strong>
        <strong className="w-15">Start Date</strong>
      </div>
      <hr className="m-0" />
      {/* Mapping through the assessment data */}
      {conditions.data.slice(0, 5).map((condition: any) => (
        <div key={condition.conditionId}>
          <div className="d-flex d-block p-3 hover-bg">
            <span className="w-85">{condition.conditionName}</span>
            <span className="w-15">
            {formateDate(condition.onsetDate, "UTC")}
            </span>
          </div>
          <hr className="m-0" />
        </div>
      ))}
    </>
  ) : (
    <div className="d-flex d-block p-3">
      <span className="alert alert-danger border-0 w-100 text-left m-2 fs-6">
        No Data Found
      </span>
    </div>
  )}
</div>

  );
};
